import React, { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useToasts } from 'react-toast-notifications';
import { getUserInfo } from '_utils/localData';
import EventTemplateStrip from './components/EventTemplateStrip';
import PaymentOptions from './components/PaymentOptions';
import AdditionalOptions from './components/AdditionalOptions';
import SelectGroup from './components/SellectGroup';
import useSelectGroup from './hooks/useSelectGroup';
import useUploadEventTemplate from '../../hooks/useUploadEventTemplate';
import EventDetails from './components/EventDetails';
// import AutoFillText from './components/AutoFillText';
import AutoFillAI from './components/AutoFillAI';

const CreateEventStep1 = () => {
  const userInfo = getUserInfo();
  const { groupOptions, selectedGroup, setSelectedGroup, isGroupDisabled } = useSelectGroup();
  const { addToast } = useToasts();
  const {
    control,
    setValue,
    reset,
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    if (selectedGroup) {
      setValue('groupId', selectedGroup, { shouldValidate: true });
    }
  }, [selectedGroup, setValue]);

  const handleUploadTemplate = useUploadEventTemplate({
    reset,
    setValue,
    addToast,
    groupId: selectedGroup,
  });

  return (
    <div className="event-hosting-step-container">
      <div style={{ maxWidth: '600px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <div>
          <Controller
            name="groupId"
            control={control}
            render={({ field }) => {
              const selectedValueObj =
                typeof field.value === 'object' && field.value !== null
                  ? field.value
                  : groupOptions.find((g) => String(g.value)
                    === String(field.value)) || selectedGroup;

              return (
                <SelectGroup
                  options={groupOptions}
                  value={selectedValueObj}
                  isDisabled={isGroupDisabled}
                  onChange={(val) => {
                    if (isGroupDisabled) return;
                    field.onChange(val);
                    setSelectedGroup(val);
                  }}
                />
              );
            }}
          />
          {errors.groupId && (
            <span style={{ color: '#E24B4A', fontSize: '11px', marginTop: '4px', display: 'block' }}>
              {errors.groupId.message}
            </span>
          )}
        </div>
        {userInfo?.isUsingFeature && (
          <AutoFillAI />
        )}
        <EventTemplateStrip onUploadTemplate={handleUploadTemplate} />
        {/* <AutoFillText /> */}
        <EventDetails />
        <PaymentOptions />
        <AdditionalOptions />
      </div>
    </div>
  );
};

export default CreateEventStep1;
